import {BaseApi} from '../shared/api';
import { createCancelTokenHandler } from '../shared/apiRequestCanceler';
import * as types from "./actionTypes";
import * as loanPlanTypes from "./loanPlanActionTypes";
import * as apiUrls from "./loanOfferApiUrls";

import { startLoading, stopLoading } from '../shared/actions'

export function fetchLoanOffer(userId, loanOfferId, onSuccess, onError) {
  return (dispatch, getState) => {
    const api = new BaseApi(dispatch, getState);

    dispatch(startLoading());
    api.getRequest(
      apiUrls.apiV2UserLoanOfferUrl(userId, loanOfferId),
      response => {
        dispatch({
          type: types.RECEIVE_LOAN_OFFER,
          payload: response.data,
        });

        onSuccess(response.data);
        dispatch(stopLoading());
      },

      errors => {
        onError();
      }
    )
  };
}

export function selectPaymentSchedule(payload) {
  return { type: types.PAYMENT_SCHEDULE_SELECTED, payload: payload };
}

export function fetchPaymentSchedules(companyId, uuid) {
    return (dispatch, getState) => {
      const api = new BaseApi(dispatch, getState, {
        headers: { 'x-api-key': process.env.REACT_APP_LMS_API_KEY }
      });

      dispatch(startLoading('paymentSchedules'));

      api.getRequest(
        apiUrls.amortizingLoanPlanSchedulesUrl(companyId, uuid),
        (response) => {
          dispatch({
            type: types.PAYMENT_SCHEDULE_FETCH_SUCCESS,
            payload: response.data.data.attributes.plan,
          });
          dispatch(stopLoading('paymentSchedules'));
        }
      );
    };
}

export function calculatePaymentSchedules(
  companyId,
  params,
  onSuccess = () => {},
  onError = () => {}
) {
  const action = 'calculatePaymentSchedules';
  return (dispatch, getState) => {
    const api = new BaseApi(dispatch, getState, {
      headers: { 'x-api-key': process.env.REACT_APP_LMS_API_KEY },
      // TODO: Replace with next line when working locally
      // headers: { 'x-api-key': process.env.REACT_APP_LMS_FCA_API_KEY}
    });

    dispatch(startLoading(action));

    api.postRequest(
      apiUrls.calculatePaymentSchedulesUrl(companyId),
      params,
      (response) => {
        dispatch({
          type: types.PAYMENT_SCHEDULE_CALCULATE_SUCCESS,
          payload: response.data.data.attributes.plan,
        });
        dispatch(stopLoading(action));
        onSuccess(response);
      },
      (error) => {
        dispatch(stopLoading(action));
        onError(error);
      },
      cancelPaymentScheduleRequestObject[action].handleRequestCancellation()
        .token
    );
  };
}

const cancelPaymentScheduleRequestObject = createCancelTokenHandler({
  calculatePaymentSchedules,
});

export function createPaymentSchedules(companyId,
  params,
  onSuccess = () => {},
  onError = () => {}
  ) {
    const action = 'createPaymentSchedules';
    return (dispatch, getState) => {
      const api = new BaseApi(dispatch, getState, {
        headers: { 'x-api-key': process.env.REACT_APP_LMS_API_KEY }
        // TODO: Replace with next line when working locally
        // headers: { 'x-api-key': process.env.REACT_APP_LMS_FCA_API_KEY}
      });
      const plan_params = {
        payment_plan: { plan: JSON.stringify({ loan_plan_preview_schedules: [params] }) },
      };
      dispatch(startLoading(action));

      api.postRequest(
        apiUrls.createAmortizingLoanPlanSchedulesUrl(companyId),
        plan_params,
        (response) => {
          dispatch({
            type: types.PAYMENT_SCHEDULE_CREATE_SUCCESS,
            payload: response.data.data.attributes.plan,
          });
          dispatch(stopLoading(action));
          onSuccess(response);
        },
        (error) => {
          dispatch(stopLoading(action));
          onError(error);
        }
      );
    };
}

export function chooseOption(
  userId,
  id,
  body,
  onSuccess)
{
  return (dispatch, getState) => {
    dispatch(startLoading());
    const api = new BaseApi(dispatch, getState);

    api.putRequest(
      apiUrls.chooseOption(userId, id),
      body,
      response => {
        dispatch(acceptLoanOffer(userId, id, null, onSuccess));
      },
      errors => {
        dispatch(stopLoading());
      }
    )
  };
}

export function acceptLoanOffer(
  userId,
  id,
  scheduleId,
  onSuccess)
{
  return (dispatch, getState) => {
    const api = new BaseApi(dispatch, getState);
    dispatch(startLoading());
    api.postRequest(
      apiUrls.accept(userId, id),
      { schedule_id: scheduleId },
      response => {
        dispatch({
          type: loanPlanTypes.RECEIVE_LOAN_PLAN,
          payload: response.data,
        });

        onSuccess(response.data.id);
        dispatch(stopLoading());
      }
    )
  };
}

export function confirmDrawDown(userId, payload, onSuccess, onError) {
  return (dispatch, getState) => {
    const api = new BaseApi(dispatch, getState);
    dispatch(startLoading());
    api.postRequest(
      apiUrls.confirm(userId),
      payload,
      (response) => {
        dispatch({
          type: loanPlanTypes.CREATE_DRAW_DOWN,
        });
        dispatch(stopLoading());
        onSuccess(response.data.id);
      },(error) =>{
        dispatch({ type: 'HANDLE_ERRORS', payload: { message: (error.message) } });
        dispatch(stopLoading());        
      }
    );
  };
}


// WEBPACK FOOTER //
// ./src/features/loans/loanOfferActions.js